import { FC } from 'react';
import '../styles/KeyboardHintsFooter.less';

const hints: { keys: string[]; label: string; }[] = [
  { keys: ['Enter'], label: 'confirm' },
  { keys: ['Tab', '⇧Tab'], label: 'next/prev' },
  { keys: ['Esc'], label: 'back/close' },
];

export const KeyboardHintsFooter: FC = () => (
  <div className='xm-search-modal-hints'>
    {hints.map(({ keys, label }) => (
      <span key={label} className='xm-search-modal-hints-item'>
        {keys.map((k) => <kbd key={k}>{k}</kbd>)}
        {label}
      </span>
    ))}
  </div>
);
